// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepAiPointSelect__UKYhy {
  padding-top: 20px;
}
@media (max-width: 850px) {
  .stepAiPointSelect__UKYhy {
    padding-top: 10px;
  }
}

.stepAiPointSelectDescr__YJswQ {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-top: 0px;
  margin-bottom: 25px;
}
@media (max-width: 850px) {
  .stepAiPointSelectDescr__YJswQ {
    font-size: 10px;
    margin-bottom: 6px;
  }
}

.hardwareFormWrapper__mna4L {
  display: flex;
  flex-direction: column;
  row-gap: 9px;
}

.quickSearchLabel__d5O_5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.quickSearchWrapper__K9I2y {
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 2px;
  background: var(--tables-secondary-row-sub-title-surface);
}

.fieldLabel__iuqu2 {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
}
@media (max-width: 850px) {
  .fieldLabel__iuqu2 {
    font-size: 8px;
    line-height: 10px;
  }
}

.itemWrapper__ECM_i {
  display: flex;
  column-gap: 20px;
}

.disabledMark__nD1mh {
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  background-color: var(--labels-filled-surface-standard);
  border-radius: 50%;
}

.emptySelectData__vFUt0 {
  height: 100%;
  padding: 12px;
  color: var(--inputs-focus-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/AddActionItemModal/components/StepAIPointSelect/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,iBAAA;AAzEF;AA2EE;EAHF;IAII,iBAAA;EAxEF;AACF;;AA2EA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAxEF;AA0EE;EATF;IAUI,eAAA;IACA,kBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAvEF;;AA0EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAvEF;;AA0EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,yDAAA;AAvEF;;AA0EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAvEF;AAyEE;EARF;IASI,cAAA;IACA,iBAAA;EAtEF;AACF;;AAyEA;EACE,aAAA;EACA,gBAAA;AAtEF;;AAyEA;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,uDAAA;EACA,kBAAA;AAtEF;;AAyEA;EACE,YAAA;EACA,aAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.stepAiPointSelect {\n  padding-top: 20px;\n\n  @media (max-width: 850px) {\n    padding-top: 10px;\n  }\n}\n\n.stepAiPointSelectDescr {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  margin-top: 0px;\n  margin-bottom: 25px;\n\n  @media (max-width: 850px) {\n    font-size: 10px;\n    margin-bottom: 6px;\n  }\n}\n\n.hardwareFormWrapper {\n  display: flex;\n  flex-direction: column;\n  row-gap: 9px;\n}\n\n.quickSearchLabel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.quickSearchWrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 15px;\n  border-radius: 2px;\n  background: var(--tables-secondary-row-sub-title-surface);\n}\n\n.fieldLabel {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  text-transform: uppercase;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 10px;\n  }\n}\n\n.itemWrapper {\n  display: flex;\n  column-gap: 20px;\n}\n\n.disabledMark {\n  width: 6px;\n  height: 6px;\n  flex-shrink: 0;\n  background-color: var(--labels-filled-surface-standard);\n  border-radius: 50%;\n}\n\n.emptySelectData {\n  height: 100%;\n  padding: 12px;\n  color: var(--inputs-focus-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepAiPointSelect": `stepAiPointSelect__UKYhy`,
	"stepAiPointSelectDescr": `stepAiPointSelectDescr__YJswQ`,
	"hardwareFormWrapper": `hardwareFormWrapper__mna4L`,
	"quickSearchLabel": `quickSearchLabel__d5O_5`,
	"quickSearchWrapper": `quickSearchWrapper__K9I2y`,
	"fieldLabel": `fieldLabel__iuqu2`,
	"itemWrapper": `itemWrapper__ECM_i`,
	"disabledMark": `disabledMark__nD1mh`,
	"emptySelectData": `emptySelectData__vFUt0`
};
module.exports = ___CSS_LOADER_EXPORT___;
